import { SetupConfiguration } from '@/types/setup';

export const SETUP_STORAGE_KEY = 'setup-config';

export const loadSetupConfiguration = (): SetupConfiguration | null => {
  try {
    const stored = localStorage.getItem(SETUP_STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    console.warn('Failed to load setup configuration from localStorage:', error);
  }
  return null;
};

export const saveSetupConfiguration = (config: SetupConfiguration): void => {
  try {
    localStorage.setItem(SETUP_STORAGE_KEY, JSON.stringify(config));
  } catch (error) {
    console.warn('Failed to save setup configuration to localStorage:', error);
    throw error;
  }
};

export const clearSetupConfiguration = (): void => {
  try {
    localStorage.removeItem(SETUP_STORAGE_KEY);
  } catch (error) {
    console.warn('Failed to clear setup configuration from localStorage:', error);
  }
};

export const isSetupComplete = (): boolean => {
  const config = loadSetupConfiguration();
  if (!config) return false;
  
  return (
    config.setupCompleted &&
    config.apiKeys.openWeatherMapKey.trim() !== '' &&
    config.apiKeys.newsApiKey.trim() !== '' &&
    config.locationPermissionGranted
  );
};

export const getSetupStep = (): 'apiKeys' | 'location' | 'completed' => {
  const config = loadSetupConfiguration();
  
  if (!config) return 'apiKeys';
  
  if (config.apiKeys.openWeatherMapKey.trim() === '' || config.apiKeys.newsApiKey.trim() === '') {
    return 'apiKeys';
  }
  
  if (!config.locationPermissionGranted) {
    return 'location';
  }
  
  return 'completed';
};